/* qeslint-disable */

import { CesiumFPVCameraController } from "./CesiumFPVCameraController";
import { toggleXrItems } from "./ConstruktedXR";
import { initFPVNavigation } from "./initFPVNavigation";

export function blockKeys(e: any) {
    switch (e.keyCode) {
        case 37:
        case 39:
        case 38:
        case 40:
            e.preventDefault();
            break; // Space
        default:
            break; // do not block other keys
    }
}

function createFPVController(options: any) {
    /*
    let options = {
        cesiumViewer: viewer,
        defaultCameraPositionOrientationJson: CONSTRUKTED_AJAX.default_camera_position_direction,
        isMobile: isMobile(),
        ignoreCollisionDetection: false,
        immersiveArEnabled: this._xrButton.enabled
    };
     */

    const fpvController = new CesiumFPVCameraController(options);

    fpvController.FPVStarted().addEventListener(() => {
        jQuery("body").addClass("fpv-mode-on");
        jQuery(".fpv-navigation").show();

        toggleXrItems();
        window.addEventListener("keydown", blockKeys, false);
    });

    fpvController.FPVFinished().addEventListener(() => {
        jQuery("body").removeClass("fpv-mode-on");
        jQuery(".fpv-navigation").hide();

        toggleXrItems();

        window.removeEventListener("keydown", blockKeys, false);
    });

    initFPVNavigation(fpvController);

    return fpvController;
}

export { createFPVController };
